<template>
  <div class="alarmQuery">
    <div class="title">
      <p>
        <span>告警查询</span>
      </p>
    </div>
    <div class="content">
      <!-- 搜索条件 -->
      <div class="searchBox">
        <div class="liBox">
          <p>发生时间</p>
          <el-date-picker
            v-model="happenTime"
            end-placeholder="结束时间"
            popper-class="date-style"
            range-separator="→"
            start-placeholder="开始时间"
            type="datetimerange"
            value-format="YYYY-MM-DD HH:mm:ss"
          >
          </el-date-picker>
        </div>
        <div class="liBox">
          <p>告警等级</p>
          <el-select v-model="warnLevel" placeholder="请选择告警级别">
            <el-option :value="1" label="紧急告警"></el-option>
            <el-option :value="2" label="主要告警"></el-option>
            <el-option :value="3" label="次要告警"></el-option>
            <el-option :value="4" label="警告告警"></el-option>
            <el-option :value="5" label="告警清除"></el-option>
          </el-select>
        </div>
        
        <div class="liBox" style="margin-left: calc(100% - 957px);">
          <el-button class="searchButton" type="primary" @click="searchFun">查询</el-button>
        </div>
        <div class="liBox">
          <el-button class="searchButton" @click="resetFun">重置</el-button>
        </div>
      </div>
      <div class="searchBox2">
        <div class="liBox">
          <p>告警规则</p>
          <el-select v-model="warnRule" placeholder="请选择告警规则" @change="selectHandle">
          <el-option
            v-for="item in ruleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          </el-select>
          <el-select v-model="ruleTarget" placeholder="请选择告警指标" style="margin-left: 16px;" v-if="ruleFalg">
          <el-option
            v-for="item in ruleTargetList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          </el-select>
        </div>
        <div style="display:flex">
         <div class="liBox">
          <el-button class="searchButton" type="primary" @click="batchWarnHandle" v-if="selectloading">批量结束警告</el-button>
        </div>
        <div class="liBox">
          <el-button class="searchButton" @click="batchworkOrder" v-if="selectloading">批量转工单</el-button>
        </div>
        </div>
      </div>
      <!-- 选中提示 -->


      <!-- 数据列表 -->
      <div class="contain">
        <el-table
          ref="tableRef"
          v-loading="loading"
          :data="tableData"
          stripe
          style="width: 100%"
          table-layout="auto"
          @selection-change="handleSelectionChange"
          @select-all="handleSelectAll"
          @select="handleSelect"
          row-key="id"
        >
          <template #empty>
            <el-empty image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/noData.png">
            </el-empty>
          </template>

          <!-- 自定义表头全选框 -->
          <el-table-column type="selection" width="55">
            <template #header>
              <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleHeaderCheckChange"
              />
            </template>
          </el-table-column>

          <el-table-column label="告警设备" prop="equipmentName"></el-table-column>
          <el-table-column
            label="告警等级"
            prop="levelStr"
            :filter-method="filterHandler"
            :filters="[
              { text: '紧急', value: '紧急' },
              { text: '主要', value: '主要' },
              { text: '次要', value: '次要' },
              { text: '警告', value: '警告' },
              { text: '告警清除', value: '告警清除' },
            ]"
          >
            <template #default="scope">
              <p v-if="scope.row.level === 1" class="level level1">{{ scope.row.levelStr }}</p>
              <p v-if="scope.row.level === 2" class="level level2">{{ scope.row.levelStr }}</p>
              <p v-if="scope.row.level === 3" class="level level3">{{ scope.row.levelStr }}</p>
              <p v-if="scope.row.level === 4" class="level level4">{{ scope.row.levelStr }}</p>
              <p v-if="scope.row.level === 5" class="level level5">{{ scope.row.levelStr }}</p>
            </template>
          </el-table-column>
          <el-table-column label="发生时间" prop="time"></el-table-column>
          <el-table-column label="规则名称" prop="ruleName"></el-table-column>
          <el-table-column label="触发规则" prop="triggerRule"></el-table-column>
          <el-table-column label="触发值" prop="nowValue"></el-table-column>
          <el-table-column label="通知人" prop="memberList">
            <template #default="scope">
              <p>{{ scope.row.memberList && scope.row.memberList.join(',') }}</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="300px">
            <template #default="scope">
              <span class="editClass btn" @click.prevent="workOrderClick(scope.row.id, scope.row)" v-if="scope.row.level !== 5">转工单</span>
              <span class="editClass btn" @click.prevent="closeWarnClick(scope.row.id, scope.row)" v-if="scope.row.level !== 5">结束警告</span>
              <span class="editClass btn" @click.prevent="disableWarnClick(scope.row.id, scope.row)" v-if="scope.row.excluded">去除设备</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div v-if="tableData.length > 0" class="pag">
          <el-pagination
            v-model:page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="total"
            background
            layout="total, prev, pager, next, sizes"
            small
            @size-change="handleSizeChange"
            @current-change="pageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'
import qs from 'qs'
import { endAlarmAPi, getAlarmListAPi2, excludedApi, warnRuleListApi ,targetRuleListApi ,batchWarnApi} from '@/api/modules/alarm'
import './alarmQuery.less'
import { log } from 'mathjs'

const router = useRouter()

// 搜索条件
const happenTime = ref([])
const warnLevel = ref()
const warnRule = ref()
const ruleTarget = ref()

// 表格数据
const tableData = ref([])
const loading = ref(false)
const tableRef = ref(null)

// 分页
const pageNumber = ref(1)
const pageSize = ref(20)
const total = ref(0)

// 选中状态管理
const selectedIds = ref(new Set()) // 存储所有选中ID
const checkAll = ref(false) // 当前页全选状态
const isIndeterminate = ref(false) // 半选状态
const selectloading = ref(false)
const dictId=ref()
const ruleTargetList=ref()
const ruleFalg=ref(false)
const selectHandle = async () => {
  // 立即清除旧数据
  ruleTarget.value = '';
  ruleTargetList.value = [];
  ruleFalg.value = false;
  selectloading.value=false
  // 参数校验
  if (!warnRule.value) {
    console.log('无有效ruleId');
    return;
  }

  try {
    const params = { ruleId: warnRule.value };
    const res = await targetRuleListApi(qs.stringify(params));
    
    // 数据结构校验
    if (res?.data?.result?.length) {
      ruleTargetList.value = res.data.result;
      ruleFalg.value = true; // 控制显示
    } else {
      console.warn('无有效数据', res.data);
    }
  } catch (err) {
    console.error('请求异常', err);
    ElMessage.error('数据加载失败');
  }
};
//批量结束工单
const batchworkOrder = () => {
  if (!selectedRows.value || selectedRows.value.length === 0) {
    console.error('No selected rows');
    return;
  }

  // 拼接所有equipmentName
  const equipmentNames = selectedRows.value.map(item => item.equipmentName);
  const equipmentNameStr = equipmentNames.join(',');
   const id = selectedRows.value.map(item => item.id);
  const idList = id.join(',');
  // 取第一个元素的其他参数
  const firstRow = selectedRows.value[0];
  
  console.log(equipmentNameStr, '拼接后的equipmentName');
  
  router.push({
    path: '/admin/workOrder',
    query: {
      batch: "isBatch", 
      equipmentName: equipmentNameStr,  // 使用拼接后的字符串
      levelStr: firstRow.levelStr,       // 取第一个元素的levelStr
      triggerRule: firstRow.triggerRule, // 取第一个元素的triggerRule
      nowValue: firstRow.nowValue,       // 取第一个元素的nowValue
      id: idList                 // 取第一个元素的id
    }
  });
};
// 批量结束告警
const batchWarnHandle = async () => {
  console.log(selectedRows,'selectedRows')
  // 确保selectedIds是数组格式
  const result = Array.from(selectedIds.value)
  const ids = result.join(',');
  // 验证数据格式
  if (ids.length === 0) {
    ElMessage.warning('请至少选择一条记录')
    return
  }
  console.log('传递的ID数组:', ids)
  
  try {
    const res = await batchWarnApi( qs.stringify({ids}))
    if (res.data.code === 0) {
      ElMessage.success(`成功结束${ids.length}条告警`)
      getListFun()
      selectedIds.value.clear() // 操作后清空选中
    } else {
      ElMessage.error(res.data.message || '操作失败')
    }
  } catch (error) {
    ElMessage.error('请求异常')
    console.error('批量结束告警失败:', error)
  }
}
// 获取告警列表
const getListFun = async function () {
  loading.value = true
  try {
    const res = await getAlarmListAPi2(
      qs.stringify({
        pageNumber: pageNumber.value,
        pageSize: pageSize.value,
        startTime: happenTime.value?.[0],
        endTime: happenTime.value?.[1],
        level: warnLevel.value,
        ruleId:warnRule.value,
        dictId:ruleTarget.value
      })
    )

    if (res.data.code === 0) {
      tableData.value = res.data.result.list
      total.value = Number(res.data.result.total)

      // 等待DOM更新后回显选中状态
      await nextTick()
      updateTableSelection()
      updateCheckAllStatus()
    } else {
      ElMessage.error(res.data.message)
    }
  } catch (err) {
    console.error(err)
  } finally {
    loading.value = false
  }
}
//
const ruleList=ref()
const warnRuleListHandle = () => {
  warnRuleListApi().then((res) => { // 修改参数名避免混淆
    // 正确做法：创建新变量存储处理后的数据
    ruleList.value = res.data.result

    console.log(ruleList, '处理后的数据');
  }).catch((err) => {
    console.error('请求失败', err);
  });
};

// 更新表格选中状态
const updateTableSelection = () => {
  tableData.value.forEach((row) => {
    const isSelected = selectedIds.value.has(row.id)
    tableRef.value?.toggleRowSelection(row, isSelected)
  })
}

// 更新表头全选框状态
const updateCheckAllStatus = () => {
  const currentPageIds = tableData.value.map((row) => row.id)
  const selectedCount = currentPageIds.filter((id) => selectedIds.value.has(id)).length

  checkAll.value = selectedCount === currentPageIds.length && currentPageIds.length > 0
  isIndeterminate.value = selectedCount > 0 && selectedCount < currentPageIds.length
}

const selectedRows = ref([])

// 修改handleSelect方法
const handleSelect = (selection, row) => {
  if (selection.includes(row)) {
    selectedIds.value.add(row.id)
    // 添加完整行数据
    selectedRows.value.push(row)
  } else {
    selectedIds.value.delete(row.id)
    // 移除对应行数据
    selectedRows.value = selectedRows.value.filter(item => item.id !== row.id)
  }
  updateCheckAllStatus()
}

// 修改handleSelectAll方法
const handleSelectAll = (selection) => {
  const currentPageRows = [...tableData.value]
  
  if (selection.length > 0) {
    // 全选时添加当前页所有行
    selectedRows.value = [
      ...selectedRows.value.filter(item => !currentPageRows.some(row => row.id === item.id)),
      ...currentPageRows
    ]
    currentPageRows.forEach(row => selectedIds.value.add(row.id))
  } else {
    // 取消全选时移除当前页所有行
    selectedRows.value = selectedRows.value.filter(
      item => !currentPageRows.some(row => row.id === item.id)
    )
    currentPageRows.forEach(row => selectedIds.value.delete(row.id))
  }
  updateCheckAllStatus()
}

// 处理表头复选框点击
const handleHeaderCheckChange = (checked) => {
  tableRef.value?.toggleAllSelection()
}

// 处理选择变化（Element内部使用）
const handleSelectionChange = () => {
  // 不修改selectedIds，避免状态冲突
}

// 清除所有选择
const clearSelection = () => {
  selectedIds.value.clear()
  updateTableSelection()
  updateCheckAllStatus()
}

// 查询
const searchFun = () => {
  console.log(tableData.value,'warnRule11');
  if(ruleTarget.value){
     selectloading.value=true
     console.log(dictId,'dictId');
  }else{
    selectloading.value=false
  }
  pageNumber.value = 1
  getListFun()
}

// 重置
const resetFun = () => {
  happenTime.value = []
  warnLevel.value = ''
  warnRule.value=''
  pageNumber.value = 1
  pageSize.value = 20
  selectedIds.value.clear() // 清除选中状态
  getListFun()
}

// 分页切换
const handleSizeChange = (size) => {
  pageSize.value = size
  pageNumber.value = 1
  getListFun()
}

const pageChange = (page) => {
  pageNumber.value = page
  getListFun()
}

// 停用警告
const disableWarnClick = (id, row) => {
  excludedApi(
    qs.stringify({
      warnLogId: id,
      equipmentIdStr: row.equipmentIdStr,
      ruleId: row.ruleId,
    })
  )
    .then(() => {
      ElMessage.success('状态更新成功')
      getListFun()
    })
    .catch(() => {
      // 错误处理
    })
}

// 转工单
const workOrderClick = (id, scope) => {
  router.push({
    path: '/admin/workOrder',
    query: {
      equipmentName: scope.equipmentName,
      levelStr: scope.levelStr,
      triggerRule: scope.triggerRule,
      nowValue: scope.nowValue,
      id:id
    },
  })
}

// 结束警告
const closeWarnClick = (id, row) => {
  ElMessageBox.confirm('请确认是否要结束此告警', 'Warning', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
    title: '',
  })
    .then(() => {
      endAlarmAPi(qs.stringify({ id: id })).then((res) => {
        if (res.data.code === 0) {
          ElMessage.success('结束告警成功')
          getListFun()
        } else {
          ElMessage.error(res.data.message)
        }
      })
    })
    .catch(() => {
      ElMessage.info('已取消结束告警')
    })
}

// 过滤方法
const filterHandler = (value, row, column) => {
  const property = column['property']
  return row[property] === value
}

onMounted(() => {
  getListFun()
  warnRuleListHandle()

})
</script>

<style lang="less" scoped>
// 选中提示样式


// 告警等级样式（保持原有）
.level {
  font-weight: bold;
  &.level1 { color: #f56c6c; }
  &.level2 { color: #e6a23c; }
  &.level3 { color: #409eff; }
  &.level4 { color: #909399; }
  &.level5 { color: #67c23a; }
}

// 按钮样式（保持原有）
.btn {
  cursor: pointer;
  margin-right: 10px;
  color: #409eff;
  &:hover {
    text-decoration: underline;
  }
}

// 分页样式
.pag {
  margin-top: 20px;
  text-align: right;
}
</style>